import globalStyles from "./global";
import backendStyles from "./backend";
import frontendStyles from "./frontend";
import readerStyles from "./reader";

export default `
  ${globalStyles}
  ${backendStyles}
  ${frontendStyles}
  ${readerStyles}
`;
